__turbopack_context__.v({
  "arrow": "PortalReviewSummary-module__OTxSyG__arrow",
  "count": "PortalReviewSummary-module__OTxSyG__count",
  "link": "PortalReviewSummary-module__OTxSyG__link",
  "prompt": "PortalReviewSummary-module__OTxSyG__prompt",
  "score": "PortalReviewSummary-module__OTxSyG__score",
});
